import { render, staticRenderFns } from "./TypographyPresetChooserInput.vue?vue&type=template&id=b883d5a0&"
import script from "./TypographyPresetChooserInput.vue?vue&type=script&lang=ts&"
export * from "./TypographyPresetChooserInput.vue?vue&type=script&lang=ts&"
import style0 from "./TypographyPresetChooserInput.vue?vue&type=style&index=0&id=b883d5a0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports